module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.frib.msu.edu",
    "title": "Facility for Rare Isotope Beams at Michigan State University",
    "tfn": "888-341-8519",
    "url": "https://info.frib.msu.edu",
    "gtm_code": "GTM-WVWBVT6",
}